export class SeedReturnLandingFilterVM {
  productLineId: any;
  productName: string;
  itemNo: string;
  accountName: string;
  accountCity: string;
  accountState: string;
  account: string;
  fromOrderDate: any;
  toOrderDate: any;
  returnRequestNumber: string;
  processingStatus: string;
  notification: string;

  productLineFilter: any;
  customerPO: string;
  branchPlant: string;
}
